/* RESPONSIBLE TEAM: team-ai-agent */

import { AiAgentEventType } from 'embercom/objects/inbox/renderable/ai-agent-event';

export type AiAgentEventData = {
  [AiAgentEventType.OtpEmailTriggeredForVerification]?: {
    title: string;
    actionId: number;
  };
  [AiAgentEventType.AiCategoriesEscalation]?: {
    ruleName: string;
  };
  [AiAgentEventType.AiAgentIgnoringUserMessage]?: {
    reason: string;
  };
  [AiAgentEventType.AiCategoriesReasoning]?: {
    reasoning: string;
  };
  [AiAgentEventType.AiAgentWorkflowStarted]?: {
    title: string;
    id: number;
    rulesetId: number;
    reasoning?: string;
  };
  [AiAgentEventType.AiAgentWorkflowFinished]?: {
    title: string;
    id: number;
    rulesetId: number;
  };
  [AiAgentEventType.AiAgentWorkflowFailed]?: {
    title: string;
    id: number;
    rulesetId: number;
  };
  [AiAgentEventType.AiAgentWorkflowStopped]?: {
    title: string;
    id: number;
    rulesetId: number;
  };
};

export type AiAgentEventDataWireFormat = {
  [K in keyof AiAgentEventData]: KeysToSnakeCase<AiAgentEventData[K]>;
};

export class AiAgentEventDataBuilder {
  static deserialize(json: AiAgentEventDataWireFormat): AiAgentEventData {
    let data: AiAgentEventData = {};

    if (json.otp_email_triggered_for_verification) {
      data[AiAgentEventType.OtpEmailTriggeredForVerification] = {
        title: json.otp_email_triggered_for_verification.title,
        actionId: json.otp_email_triggered_for_verification.action_id,
      };
    }

    if (json.ai_categories_escalation) {
      data[AiAgentEventType.AiCategoriesEscalation] = {
        ruleName: json.ai_categories_escalation.rule_name,
      };
    }

    if (json.ai_agent_ignoring_user_message) {
      data[AiAgentEventType.AiAgentIgnoringUserMessage] = {
        reason: json.ai_agent_ignoring_user_message.reason,
      };
    }

    if (json.ai_categories_reasoning) {
      data[AiAgentEventType.AiCategoriesReasoning] = {
        reasoning: json.ai_categories_reasoning.reasoning,
      };
    }

    if (json.ai_agent_workflow_started) {
      let value: AiAgentEventData[AiAgentEventType.AiAgentWorkflowStarted] = {
        title: json.ai_agent_workflow_started.title,
        id: json.ai_agent_workflow_started.id,
        rulesetId: json.ai_agent_workflow_started.ruleset_id,
      };
      if (json.ai_agent_workflow_started.reasoning !== undefined) {
        value.reasoning = json.ai_agent_workflow_started.reasoning;
      }
      data[AiAgentEventType.AiAgentWorkflowStarted] = value;
    }

    if (json.ai_agent_workflow_finished) {
      data[AiAgentEventType.AiAgentWorkflowFinished] = {
        title: json.ai_agent_workflow_finished.title,
        id: json.ai_agent_workflow_finished.id,
        rulesetId: json.ai_agent_workflow_finished.ruleset_id,
      };
    }

    if (json.ai_agent_workflow_stopped) {
      data[AiAgentEventType.AiAgentWorkflowStopped] = {
        title: json.ai_agent_workflow_stopped.title,
        id: json.ai_agent_workflow_stopped.id,
        rulesetId: json.ai_agent_workflow_stopped.ruleset_id,
      };
    }

    if (json.ai_agent_workflow_failed) {
      data[AiAgentEventType.AiAgentWorkflowFailed] = {
        title: json.ai_agent_workflow_failed.title,
        id: json.ai_agent_workflow_failed.id,
        rulesetId: json.ai_agent_workflow_failed.ruleset_id,
      };
    }

    return data;
  }
}
